import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    border: `1px solid ${theme.palette.grey[300]}`,
    borderRadius: 8,
    margin: '8px 0'
  },
  top: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: theme.spacing(2)
  },
  middle: {
    display: 'flex',
    padding: theme.spacing(2),
    paddingBottom: 0,
    flexDirection: 'column'
  },
  bottom: { display: 'flex', padding: '0px 16px 8px 16px' },
  formContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(0.5),
    width: '100%',
    padding: theme.spacing(2),
    margin: '16px 0',
    borderRadius: 8
  },
  row: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr 1fr',
    gap: theme.spacing(2),
    [theme.breakpoints.down('sm')]: {
      gridTemplateColumns: '1fr',
      gap: 0
    }
  },
  input: {
    height: 38
  },
  header: {
    fontWeight: 600,
    color: theme.palette.text.primary
  },
  btnText: { fontWeight: 600, color: theme.palette.primary.contrastText },
  radioIcon: {
    '& svg': {
      fontSize: 18
    }
  },
  label: { color: theme.palette.text.primary, fontSize: 14 }
}))
